import { IonCol, IonGrid, IonRow } from "@ionic/react";
import React from "react";

export const Loading = (props: { loading: any; children: any }) => {
  let srcImg = process.env.PUBLIC_URL + "/imgs/loading.gif";

  var result = props.children;

  if (props.loading) {
    result = (
      <IonGrid>
        <IonRow className="ion-text-center">
          <IonCol size="12">
            <img style={{ width: "100vh" }} src={srcImg} alt="home"></img>
          </IonCol>
        </IonRow>
      </IonGrid>
    );
  }

  return result;
};
